"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// import { createRoot } from 'react-dom/client';
const react_dom_1 = require("react-dom");
// import moment from 'moment';
// import injectTapEventPlugin from 'react-tap-event-plugin';
// import momentLocalizer from 'react-widgets-moment';
const mobx_1 = require("mobx");
require("react-widgets/styles.css");
require("./style.css");
const Main_1 = __importDefault(require("./components/Main"));
(0, mobx_1.configure)({
    enforceActions: 'always',
});
// moment.locale('en');
// momentLocalizer();
// injectTapEventPlugin();
// const root = createRoot(document.querySelector('#app'))
// root.render(<Main />);
(0, react_dom_1.render)(react_1.default.createElement(Main_1.default, null), document.querySelector('#app') // eslint-disable-line
);
